// extracted by mini-css-extract-plugin
module.exports = {"AppleLogin":"styles_AppleLogin__hrnfd","AppleLogin-btn":"styles_AppleLogin-btn__0kxIb"};